import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {
  userProfile: any = {};
  employeeId: any;
  otp: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: true,
    // disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe(response => {
      console.log(`queryParams ${JSON.stringify(response)}`)
      if (response.employeeId) {
        this.employeeId = response.employeeId;
      } else {
        this.router.navigate(["resgister"]);
      }
    });
  }

  async ngOnInit() {
    try {
      this.userProfile = await this.apiService.initLineLiffSDK();
    } catch (err) {
      console.log(`${err}!`);
    }
  }
  async onOtpChange(event: any) {
    try {
      if (event.length === 6) {
        //console.log(event);
        this.otp = event;
        this.ngOtpInputRef.otpForm.disable();
        var response: any = await this.accessLineUser();
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: response.sendMessage
          }).then(res => {
            const request_body = "คุณได้ลงทะเบียนสำเร็จ";
            this.apiService.sendMessagesSDK(request_body);
            this.apiService.closeWindowSDK();
            this.router.navigate(["resgister"]);
          });
        } else if (!response.success) {
          Swal.fire({
            icon: "error",
            title: response.sendMessage
          }).then(res => {
            if(response.CountIOTPIncorrect === 2){
              this.router.navigate(["resgister"]);
            }
            this.ngOtpInputRef.setValue('');
            this.ngOtpInputRef.otpForm.enable();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: response
          }).then(res => {
            this.ngOtpInputRef.setValue('');
            this.ngOtpInputRef.otpForm.enable();
          });
        }
      }
    }catch(err){
      Swal.fire({
        icon: "error",
        title: err
      }).then(res => {
        this.ngOtpInputRef.setValue('');
        this.ngOtpInputRef.otpForm.enable();
      });
    }
  }
  async accessLineUser() {
    return await new Promise(async (resolve, reject) => {
      try {
        const request_body = {
          LineId: this.userProfile?.userId ? this.userProfile?.userId : "",
          EmployeeUser: this.employeeId ? this.employeeId : "",
          OTP: this.otp,
          ResetOTP: 0
        };
        await this.apiService.accessLineUser(request_body)
          .toPromise()
          .then(async (response: any) => {
            resolve(response);
          }).catch(async (err: any) => reject(err));
      } catch (err) {
        reject(err);
      }
    });
  }
  async onSendOtpAgain() {
    return await new Promise(async (resolve, reject) => {
      try {
        const request_body = {
          LineId: this.userProfile?.userId ? this.userProfile?.userId : "",
          EmployeeUser: this.employeeId ? this.employeeId : "",
          ResetOTP: 1
        };
        await this.apiService.accessLineUser(request_body)
          .toPromise()
          .then(async (response: any) => {
            resolve(response);
          }).catch(async (err: any) => reject(err));
      } catch (err) {
        reject(err);
      }
    });
  }
}
